module.exports = __webpack_public_path__ + "media/images/note-d1c4b39bf0870daadb9a60717408961f.gif";